module.exports = __webpack_public_path__ + "static/media/go-back.5a0e7b68.svg";